<dx-box width="100%" height="100%" direction="col">
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <fieldset class="field-set dx-theme-border-color">
                <legend class="legend-title">AP Invoice Line Items</legend>
                <dx-toolbar width="100%">
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Add"
                                hint="Add"
                                [icon]="iconPlus"
                                (onClick)="onAddNewLineItem()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </fieldset>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate class="grid-container dx-theme-border-color">
            <dx-data-grid
                #lineItemGrid
                ccAddNewRow
                width="100%"
                height="100%"
                keyExpr="itemId"
                [highlightChanges]="true"
                [repaintChangesOnly]="true"
                [allowColumnReordering]="true"
                [allowColumnResizing]="true"
                [showBorders]="true"
                [showColumnLines]="true"
                [showRowLines]="true"
                [wordWrapEnabled]="true"
                [dataSource]="gridLineItems"
                [columnWidth]="100"
                (onRowUpdated)="onRowUpdated($event)"
                (onContentReady)="onEditorContentReady($event)"
                (onAddNewRow)="onAddNewLineItem()"
            >
                <dxo-editing
                    mode="cell"
                    refreshMode="full"
                    [selectTextOnEditStart]="true"
                    [allowUpdating]="true"
                    [useIcons]="true"
                ></dxo-editing>
                <dxi-column
                    caption="Action"
                    alignment="center"
                    cellTemplate="actionCellTemplate"
                    [width]="50"
                    [allowEditing]="false"
                ></dxi-column>
                <dxi-column
                    dataType="number"
                    caption="Item #"
                    cellTemplate="itemNumber"
                    [width]="50"
                    [allowEditing]="false"
                ></dxi-column>
                <dxi-column
                    dataType="string"
                    dataField="glAccountNumber"
                    caption="Account"
                    headerCellTemplate="requiredColumnHeaderTemplate"
                    editCellTemplate="glAccountTemplate"
                    [width]="250"
                    [allowSorting]="false"
                    [showEditorAlways]="true"
                    [allowEditing]="true"
                ></dxi-column>
                <ng-container *ngIf="entityUsesSubCategory">
                    <dxi-column
                        dataField="subCategoryId"
                        dataType="string"
                        caption="Sub Category"
                        editCellTemplate="subCategoryTemplate"
                        [width]="250"
                        [allowSorting]="false"
                        [allowEditing]="true"
                        [showEditorAlways]="true"
                    ></dxi-column>
                </ng-container>
                <dxi-column
                    dataType="number"
                    dataField="itemAmount"
                    caption="Amount"
                    [format]="currencyFormat"
                    [allowEditing]="true"
                    [showEditorAlways]="true"
                    [editorOptions]="{
                        min: 0,
                        showClearButton: true,
                        format: currencyFormat
                    }"
                ></dxi-column>
                <ng-container *ngIf="dimensionSource.length > 0">
                    <ng-container *ngFor="let col of dimensionSource">
                        <ng-container *ngIf="requireDimensionMatch">
                            <dxi-column
                                dataType="string"
                                headerCellTemplate="requiredDimensionColumnHeaderTemplate"
                                [allowSorting]="false"
                                [dataField]="col.code"
                                [caption]="col"
                                [width]="120"
                                [showEditorAlways]="!col.required"
                                [allowEditing]="!col.required"
                            >
                                <dxo-lookup
                                    displayExpr="text"
                                    valueExpr="code"
                                    [dataSource]="col.options"
                                    [allowClearing]="true"
                                ></dxo-lookup>
                            </dxi-column>
                        </ng-container>
                        <ng-container *ngIf="!requireDimensionMatch">
                            <dxi-column
                                dataType="string"
                                headerCellTemplate="requiredDimensionColumnHeaderTemplate"
                                [allowSorting]="false"
                                [dataField]="col.code"
                                [caption]="col"
                                [width]="120"
                                [showEditorAlways]="true"
                                [allowEditing]="true"
                            >
                                <dxo-lookup
                                    displayExpr="text"
                                    valueExpr="code"
                                    [dataSource]="col.options"
                                    [allowClearing]="true"
                                ></dxo-lookup>
                            </dxi-column>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <dxi-column dataType="string" dataField="description" caption="Description"></dxi-column>

                <div *dxTemplate="let header of 'requiredColumnHeaderTemplate'">
                    {{ header.column.caption }}
                    <sup class="cc-text-required">*</sup>
                </div>

                <div *dxTemplate="let header of 'requiredDimensionColumnHeaderTemplate'">
                    {{ header.column.caption.text }}
                    <sup *ngIf="header.column.caption.required" class="cc-text-required">*</sup>
                </div>

                <div *dxTemplate="let d of 'actionCellTemplate'">
                    <i
                        class="cc-1-5x cc-hyperlink cc-red-icon"
                        [ngClass]="iconDelete"
                        (click)="onDeleteClick(d.data)"
                    ></i>
                </div>
                <div *dxTemplate="let item of 'itemNumber'">
                    <span>
                        {{ item.row.rowIndex + 1 }}
                    </span>
                </div>

                <div *dxTemplate="let header of 'glAccountHeaderCellTemplate'">Account</div>

                <div *dxTemplate="let cellInfo of 'glAccountTemplate'">
                    <app-grid-cell-multi-column-selector
                        [name]="'GL Accounts'"
                        [gridSource]="glAccountsBudgetInfo"
                        [cellInfo]="cellInfo"
                        [dropDownButtonTemplate]="'dropDownButton'"
                        [dropDownOptions]="{ width: 'auto' }"
                        [valueExpr]="'glAccountNumber'"
                        [displayExpr]="'glAccountDisplayText'"
                        [columnDef]="glAccountColumns"
                        [showClearButton]="true"
                        [placeholder]="'Select GL Account...'"
                        (gridSelectionEvent)="onGLAccountSelection($event.selectedRow, cellInfo)"
                    ></app-grid-cell-multi-column-selector>
                </div>
                <div *dxTemplate="let cellInfo of 'subCategoryTemplate'">
                    <app-grid-cell-multi-column-selector
                        [name]="'Sub Category'"
                        [gridSource]="cellInfo.data.subCategorySource"
                        [cellInfo]="cellInfo"
                        [dropDownButtonTemplate]="'dropDownButton'"
                        [dropDownOptions]="{ width: 'auto' }"
                        [valueExpr]="'id'"
                        [displayExpr]="'title'"
                        [columnDef]="subCategoryColumns"
                        [showClearButton]="true"
                        [placeholder]="'Select Subcategory...'"
                        (gridSelectionEvent)="onSubCategorySelection($event.selectedRow, cellInfo)"
                    ></app-grid-cell-multi-column-selector>
                </div>

                <dxo-summary>
                    <dxi-total-item
                        column="itemAmount"
                        name="itemAmount"
                        summaryType="sum"
                        [customizeText]="customizeLineItemSummary"
                    ></dxi-total-item>
                </dxo-summary>
            </dx-data-grid>
        </div>
    </dxi-item>
</dx-box>

<cc-message-box #lineItemEditorMessageBox></cc-message-box>
